import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class AttendanceID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
